module.exports = __webpack_public_path__ + "img/Group10.778f5894.png";